import React from 'react';
import { Link } from 'react-router-dom';
import { cmsEditorialStatuses } from '../../../api/contentAdminApi';
import { isCmsPublished } from '../../../utils/cmsPublishHelpers';

const STATUS_HINTS = {
	draft: 'Not visible on the public site. Finish writing, then set to Published.',
	review: 'Not visible on the public site. Use when waiting for a final check.',
	published: 'Live on the public site — listed on /guides and the matching topic hub.',
	archived: 'Hidden from the public site. Keeps the URL but removes it from listings.',
};

export function CmsEditorialFields({ form, onChange }) {
	const published = isCmsPublished(form);
	const hint = STATUS_HINTS[form.editorial_status || 'draft'] || '';

	return (
		<fieldset className="admin-cms-form__section">
			<legend>Publishing & SEO</legend>
			<div className={`admin-cms-publish-hint${published ? ' admin-cms-publish-hint--live' : ''}`}>
				<strong>{published ? 'Public — tourists can see this' : 'Not public yet'}</strong>
				<p className="mb-0">{hint}</p>
			</div>
			<div className="admin-cms-form__row">
				<label>
					<span>Editorial status</span>
					<select value={form.editorial_status || 'draft'} onChange={(e) => onChange('editorial_status', e.target.value)}>
						{cmsEditorialStatuses.map((s) => <option key={s.value} value={s.value}>{s.label}</option>)}
					</select>
				</label>
				<label>
					<span>Last verified</span>
					<input type="date" value={form.last_verified_at ? form.last_verified_at.slice(0, 10) : ''} onChange={(e) => onChange('last_verified_at', e.target.value)} />
				</label>
			</div>
			<label>
				<span>Meta title</span>
				<input type="text" value={form.meta_title || ''} onChange={(e) => onChange('meta_title', e.target.value)} />
			</label>
			<label>
				<span>Meta description</span>
				<textarea rows={2} value={form.meta_description || ''} onChange={(e) => onChange('meta_description', e.target.value)} />
			</label>
			<div className="admin-cms-form__row">
				<label>
					<span>Canonical URL</span>
					<input type="url" value={form.canonical_url || ''} onChange={(e) => onChange('canonical_url', e.target.value)} />
				</label>
				<label>
					<span>OpenGraph image URL</span>
					<input type="url" value={form.og_image_url || ''} onChange={(e) => onChange('og_image_url', e.target.value)} />
				</label>
			</div>
		</fieldset>
	);
}

export function CmsFormShell({ title, backHref, children, onSubmit, saving, extraActions }) {
	return (
		<div className="admin-cms-form">
			<Link to={backHref} className="admin-cms-back">← Back to list</Link>
			<h1>{title}</h1>
			<form onSubmit={onSubmit}>
				{children}
				<div className="admin-cms-form__actions">
					{extraActions}
					<button type="submit" className="btn btn-primary" disabled={saving}>
						{saving ? 'Saving…' : 'Save'}
					</button>
				</div>
			</form>
		</div>
	);
}
